import React from "react";

import { Card, CardBody, Row, Col, Button } from "reactstrap";

import "../../styles/estilos.css";
import Page from "components/Page";
import ImgExitoso from "assets/img/icono-exitoso.png";
import ImgRechazado from "assets/img/REJECTED.png";
import ImgPendiente from "assets/img/PENDING.png";
import { FetchPost } from '../../redux/actions/api'
import { urlListarDetalleComprasGeneral } from '../../constants/urls'
import ValoresCotizacion from "./ValoresCotizacionGeneral";
//import ListadoProductos from "./ListaProductosCotizacion/ListadoProductos";
import { withRouter } from "react-router-dom";
import { Textbox } from "react-inputs-validation";
import { infoIds } from "../../constants";

class Cotizacion5ConfirmacionFinal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datos: {},
    };
    this.metodo = this.metodo.bind(this);
  }

  async componentDidMount() {
    //Consultar servicio para obtener la información de la compra
    window.scrollTo(0, 0);
    const queryParams = new URLSearchParams(this.props.location.search);
    const id = queryParams.get('id');
    console.log("dd", id)
    //Consultar servicio para obtener la información de la compra
    let resp = await FetchPost({
      url: urlListarDetalleComprasGeneral, param: {
        empresa: "AIGMETROPOLITANA",
        idCarrito: id
      }
    })
    this.setState({ datos: resp != null ? resp : {} });
  }
  obtenerUrlDocs = () => {

  }

   capitalizeFirstLetter = (string)=> {

    var aux = string.toLowerCase()
    return aux;
  }

  metodo(e) {
    e.preventDefault();
    if (this.props.estado === "APROBADO") {
      this.props.history.replace({
        pathname: "/cotizacion",
        search: `?accion=nuevo`,
      }); // Para ir a la pantalla de ramos y no permitirle regresar mediante el navegador
    }
  }

  onCompletarFVinculacon = (e) => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');
    var datosFormulario = this.props.datosFVinculacion;
    var url = window.btoa(datosFormulario.urlFormulario);
    var urlbackregreso = window.btoa(this.props.location.pathname + this.props.location.search)
    this.props.history.push({
      pathname: "/formulario-vinculacion",
      search: `?url=${url}&back=true&id=${idCarrito}&urlbackreturn=${urlbackregreso}`

    });
  }
  onEnviarForm = (e) => {
    this.props.enviarFormulario();
  }

  render() {

    const { } = this.state;
    const {
      datosContratante,
      datosPagador,
      datosItems,
      planesAdvance,
      datosAdicionales,
      estado,
      totales,
    } = this.props;
    const urlpfdFirmado = this.state.datos.urlpfdFirmado;
    const urlpdfSinFirma = this.state.datos.urlpdfSinFirma;
    let breadcrumbs = [{ name: "cotización de vehículos", active: true }];
    if (this.props.mostrarResumen === true) {
      breadcrumbs = [
        {
          name:
            this.props.datosUsuario.usu_tipo_usuario &&
              this.props.datosUsuario.usu_tipo_usuario !== "cliente"
              ? "Listado de Ventas"
              : "Listado de Compras",
          active: true,
          link: true,
          url: "/listado-compras",
        },
        { name:datosItems && datosItems[0] &&datosItems[0][0] ?"Cotización de  "+this.capitalizeFirstLetter( datosItems[0][0].contenido): "cotización de vehículos", active: true },
      ];
    }

    var datosFormulario = undefined
    if (this.props.datosFVinculacion) {
      datosFormulario = this.props.datosFVinculacion;
    }

    var mostrarEditarFormulario = false;
    if (datosFormulario !== null && datosFormulario !== undefined && datosFormulario.urlFormulario) {
      mostrarEditarFormulario = true
      if (datosFormulario.CodEstado !== undefined && datosFormulario.CodEstado !== '' && datosFormulario.CodEstado === 'FVFL') {
        mostrarEditarFormulario = false
      }
    }


    return (
      <Page title={datosItems && datosItems[0] &&datosItems[0][0]&&datosItems[0][0].contenido ?"Cotización de "+ this.capitalizeFirstLetter(datosItems[0][0].contenido):"Cotización de vehículos"} breadcrumbs={breadcrumbs}>
        <Row>
          {this.props.mostrarResumen === false && (
            <Col lg={8} md={12} sm={12} xs={12}>
              <div className="container-step">
                <div className="wrapper-step">
                  <div className="arrow-steps clearfix-step">
                    <div className="step">
                      {" "}
                      <span>1. Cotización</span>{" "}
                    </div>
                    <div className="step">
                      {" "}
                      <span>2. Resumen</span>{" "}
                    </div>
                    <div className="step current">
                      {" "}
                      <span>3. Confirmación</span>{" "}
                    </div>
                    <div class="step"> {` 4. Forma de Pago `} </div>
                    <div class="step"> {` 5. Formulario de Vinculación `} </div>
                    <div class="step"> {` 6. Emisión `} </div>
                  </div>
                </div>
              </div>
            </Col>
          )}
        </Row>
        <Row>
          <Col
            lg={8}
            md={12}
            sm={12}
            xs={12}
            className="detalle-cotizacion-box"
          >
            <Card className="flex-row">
              <CardBody>
                <Row>
                  <Col xs={12} lg={8} md={8} sm={4}>
                    {estado === "APROBADO" && (
                      <div style={{ padding: "1em" }}>
                        {this.props.mostrarResumen === false && (
                          <h2 style={{ color: "#001871" }}> FELICIDADES!</h2>
                        )}
                        {this.props.mostrarResumen === true && (
                          <h2 style={{ color: "#001871" }}>
                            {" "}
                            DETALLES DE LA{" "}
                            {this.props.datosUsuario.usu_tipo_usuario &&
                              this.props.datosUsuario.usu_tipo_usuario !==
                              "cliente"
                              ? "VENTA"
                              : "COMPRA"}
                          </h2>
                        )}
                        <h5 style={{ textAlign: "justify" }}>
                          {" "}
                          {`Tu compra es la # ${datosAdicionales && datosAdicionales.nroPoliza
                            ? datosAdicionales.nroPoliza
                            : ""
                            }`}
                          .
                        </h5>
                        {datosAdicionales && datosAdicionales.traPagoId && (
                          <h5 style={{ textAlign: "justify" }}>
                            {" "}
                            {`Referencia del Pago # ${datosAdicionales.traPagoId}`}
                            .
                          </h5>
                        )}

                        {datosAdicionales && datosAdicionales.estadoPago && (
                          <h5 style={{ textAlign: "justify" }}>
                            {" "}
                            {`Estado del Pago: ${datosAdicionales.estadoPago}`}
                          </h5>
                        )}
                        {datosAdicionales &&
                          datosAdicionales.queUsuarioRealizoCotizacion !==
                          "broker" &&
                          this.props.mostrarResumen === false && (
                            <h6>
                              Por favor revisa tu correo electrónico{" "}
                              <strong>({`${datosContratante.correo}`})</strong>{" "}
                              para continuar el proceso de contratación de la
                              póliza. A continuación los detalles de tu compra.
                            </h6>
                          )}
                      </div>
                    )}

                    {estado === "RECHAZADO" && (
                      <div style={{ padding: "1em" }}>
                        <h2 style={{ color: "#001871" }}>
                          Transacción Rechazada
                        </h2>
                        <h5>
                          {" "}
                          {`Tu transacción ha sido rechazada. Si deseas intentar nuevamente el pago puedes hacerlo mediante el botón REINTENTAR PAGO`}
                          .
                        </h5>
                        {datosAdicionales && datosAdicionales.traPagoId && (
                          <h5 style={{ textAlign: "justify" }}>
                            {" "}
                            {`Referencia del Pago # ${datosAdicionales.traPagoId}`}
                            .
                          </h5>
                        )}
                        {datosAdicionales && datosAdicionales.estadoPago && (
                          <h5 style={{ textAlign: "justify" }}>
                            {" "}
                            {`Estado del Pago: ${datosAdicionales.estadoPago}`}
                          </h5>
                        )}
                      </div>
                    )}

                    {estado === "PENDIENTE" && (
                      <div style={{ padding: "1em" }}>
                        <h2 style={{ color: "#001871" }}> EN PROCESO</h2>
                        <h5>
                          {" "}
                          {`Tu transacción esta en proceso en unos minutos recibirás un correo electrónico de confirmación del pago. Tu ${this.props.datosUsuario.usu_tipo_usuario &&
                            this.props.datosUsuario.usu_tipo_usuario !==
                            "cliente"
                            ? "venta"
                            : "compra"
                            } es la # ${datosAdicionales.nroPoliza}`}
                          .
                        </h5>
                        {datosAdicionales && datosAdicionales.traPagoId && (
                          <h5 style={{ textAlign: "justify" }}>
                            {" "}
                            {`Referencia del Pago # ${datosAdicionales.traPagoId}`}
                            .
                          </h5>
                        )}

                        {datosAdicionales && datosAdicionales.estadoPago && (
                          <h5 style={{ textAlign: "justify" }}>
                            {" "}
                            {`Estado del Pago: ${datosAdicionales.estadoPago}`}
                          </h5>
                        )}
                        <h5>
                          A continuación los detalles de tu{" "}
                          {this.props.datosUsuario.usu_tipo_usuario &&
                            this.props.datosUsuario.usu_tipo_usuario !== "cliente"
                            ? "venta."
                            : "compra."}
                        </h5>
                      </div>
                    )}
                    <div style={{ paddingLeft: "1em" }}>
                      {datosFormulario !== null && datosFormulario !== undefined && <h4 style={{ color: "#001871" }}>Detalle Formulario de Vinculacion</h4>}
                      {datosFormulario !== null && datosFormulario !== undefined && datosFormulario.Estado && <h5 style={{ textAlign: "justify" }}>Estado: {datosFormulario.Estado}</h5>}
                      {mostrarEditarFormulario &&
                        <div>
                          <Button
                            className="btn btn-purple"
                            onClick={this.onCompletarFVinculacon}
                            style={{ display: "block", margin: "0 0 0 auto", marginLeft: "0" }}
                          >
                            <i className="fa fa-pencil" aria-hidden="true" /> COMPLETAR FORMULARIO VINCULACIÓN
                          </Button>
                          <br></br>
                          <Button
                            className="btn btn-secondary"
                            onClick={this.onEnviarForm}
                            style={{ display: "block", margin: "0 0 0 auto", marginLeft: "0" }}
                          >
                            <i class="fa fa-paper-plane-o" aria-hidden="true" />{" "}
                            ENVIAR FORMULARIO AL CLIENTE
                          </Button>
                        </div>
                      }
                    </div>

                  </Col>
                  <Col
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ textAlign: "center" }}
                  >
                    {this.props.mostrarResumen === false &&
                      estado === "APROBADO" && (
                        <img
                          src={ImgExitoso}
                          width="100px"
                          alt="imagen Resumen"
                        ></img>
                      )}
                    {this.props.mostrarResumen === false &&
                      estado === "RECHAZADO" && (
                        <img
                          src={ImgRechazado}
                          width="100px"
                          alt="imagen Resumen"
                        ></img>
                      )}
                    {this.props.mostrarResumen === false &&
                      estado === "PENDIENTE" && (
                        <img
                          src={ImgPendiente}
                          width="100px"
                          alt="imagen Resumen"
                        ></img>
                      )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div style={{ padding: "1em" }}>

                      {this.props.mostrarResumen &&
                        this.state.datos &&
                        urlpdfSinFirma !== undefined && urlpdfSinFirma !== null && urlpdfSinFirma.length > 0 && (
                          <a
                            href={urlpdfSinFirma}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Button className="btn btn-primary btn btn-secondary">
                              <i
                                className="fa fa-cloud-download"
                                aria-hidden="true"
                              />{" "}
                              DESCARGAR PÓLIZA SIN FIRMA
                            </Button>&nbsp;
                          </a>
                        )}
                      {this.props.mostrarResumen === true &&
                        this.state.datos &&
                        urlpfdFirmado !== undefined && urlpfdFirmado !== null && urlpfdFirmado.length > 0 && (
                          <a
                            href={urlpfdFirmado}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Button className="btn btn-primary btn btn-secondary">
                              <i
                                className="fa fa-cloud-download"
                                aria-hidden="true"
                              />{" "}
                              DESCARGAR PÓLIZA CON FIRMA
                            </Button>

                          </a>
                        )}

                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {datosItems !== undefined &&
              datosItems.map((item, index) => (
                <Card className="flex-row ">
                  <CardBody>
                    <h4 style={{ fontWeight: "bold" }}>
                      {" "}
                      {`Item Asegurado ${index + 1}`}
                    </h4>
                    <p></p>

                    {item.map((dato, index2) => (
                      <Row>
                        <Col lg={3} md={4} sm={4} xs={12}>
                          <h5 style={{ fontWeight: "bold" }}>
                            {dato.etiqueta}
                          </h5>
                        </Col>
                        <Col lg={9} md={8} sm={8} xs={12}>
                          <Textbox
                            ref={this.textInput}
                            tabIndex="1"
                            type="text"
                            id="test"
                            name="test"
                            classNameInput={"input-type-label form-control"}
                            value={dato.contenido}
                          />
                        </Col>
                      </Row>
                    ))}
                  </CardBody>
                </Card>
              ))}

            {planesAdvance && planesAdvance.planContenidos && planesAdvance.planContenidos.valoresCobertura &&


              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }}>
                    {" "}
                    {`Plan de contenidos`}
                  </h4>
                  <p></p>

                  {planesAdvance.planContenidos.valoresCobertura.map((dato, index2) => (
                    <Row>
                      <Col lg={3} md={4} sm={4} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>
                          {dato.titulo}
                        </h5>
                      </Col>
                      <Col lg={9} md={8} sm={8} xs={12}>
                        <Textbox
                          ref={this.textInput}
                          tabIndex="1"
                          type="text"
                          id="test"
                          name="test"
                          classNameInput={"input-type-label form-control"}
                          value={'$' + parseFloat(dato.valor).toFixed(2)}
                        />
                      </Col>
                    </Row>
                  ))}
                </CardBody>
              </Card>

            }

            {planesAdvance && planesAdvance.planEstructura && planesAdvance.planEstructura.valoresCobertura &&


              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }}>
                    {" "}
                    {`Plan de estructura`}
                  </h4>
                  <p></p>

                  {planesAdvance.planEstructura.valoresCobertura.map((dato, index2) => (
                    <Row>
                      <Col lg={3} md={4} sm={4} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>
                          {dato.titulo}
                        </h5>
                      </Col>
                      <Col lg={9} md={8} sm={8} xs={12}>
                        <Textbox
                          ref={this.textInput}
                          tabIndex="1"
                          type="text"
                          id="test"
                          name="test"
                          classNameInput={"input-type-label form-control"}
                          value={'$' + parseFloat(dato.valor).toFixed(2)}
                        />
                      </Col>
                    </Row>
                  ))}
                </CardBody>
              </Card>

            }

            <Card className="flex-row ">
              <CardBody>
                <Row>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <h4 style={{ fontWeight: "bold" }}>
                      Datos del Contratante
                    </h4>
                    <p />
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Tipo de documento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosContratante.descripcionTipoDocumento} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Número de Identificación</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosContratante.identificacion} `}
                  </Col>
                </Row>
                {datosContratante.codTipodocumento !== undefined &&
                  (datosContratante.codTipodocumento === infoIds.codigoCedulaStr ||
                    datosContratante.codTipodocumento === infoIds.codigoPasaporteStr) && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Nombres</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosContratante.cliNombres}`}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Apellidos</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosContratante.cliApellidos}`}
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Estado Civil</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosContratante.descripcionEstadoCivil} `}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Género</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosContratante.descripcionGenero} `}
                        </Col>
                      </Row>
                    </div>
                  )}
                {datosContratante.codTipodocumento !== undefined &&
                  datosContratante.codTipodocumento === infoIds.codigoRucStr && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Razón Social</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosContratante.cliNombres}`}
                        </Col>
                      </Row>
                    </div>
                  )}

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Provincia</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosContratante.provincia.label} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Ciudad</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosContratante.ciudad.label} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Fecha nacimiento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosContratante.fechaNacimiento} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Correo Electrónico</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosContratante.correo} `}
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Dirección</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosContratante.direccion} `}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Celular</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosContratante.celular} `}
                  </Col>
                </Row>

                {datosContratante.codTipodocumento !== undefined &&
                  datosContratante.codTipodocumento === infoIds.codigoPasaporteStr && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Emisión Pasaporte</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosContratante.fechaEmisionPasaporte}`}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Caducidad Pasaporte</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosContratante.fechaCaducidadPasaporte}`}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Ingreso País</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosContratante.fechaIngresoPais}`}
                        </Col>
                      </Row>
                    </div>
                  )}
              </CardBody>
            </Card>

            <Card className="flex-row ">
              <CardBody>
                <Row>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <h4 style={{ fontWeight: "bold" }}>Datos de Facturación</h4>
                    <p />
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Tipo de documento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosPagador.descripcionTipoDocumento} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Número de Identificación</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosPagador.identificacion} `}
                  </Col>
                </Row>

                {datosPagador.codTipodocumento !== undefined &&
                  (datosPagador.codTipodocumento === infoIds.codigoCedulaStr ||
                    datosPagador.codTipodocumento === infoIds.codigoPasaporteStr) && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Nombres</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosPagador.cliNombres}`}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Apellidos</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosPagador.cliApellidos} `}
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Estado Civil</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosPagador.descripcionEstadoCivil} `}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Género</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosPagador.descripcionGenero} `}
                        </Col>
                      </Row>
                    </div>
                  )}

                {datosPagador.codTipodocumento !== undefined &&
                  datosPagador.codTipodocumento === infoIds.codigoRucStr && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Razón Social</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosPagador.cliNombres}`}
                        </Col>
                      </Row>
                    </div>
                  )}

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Provincia</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosPagador.provincia.label} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Ciudad</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosPagador.ciudad.label} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Fecha nacimiento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosPagador.fechaNacimiento} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Correo Electrónico</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosPagador.correo} `}
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Dirección</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosPagador.direccion} `}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Celular</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${datosPagador.celular} `}
                  </Col>
                </Row>

                {datosPagador.codTipodocumento !== undefined &&
                  datosPagador.codTipodocumento === infoIds.codigoPasaporteStr && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Emisión Pasaporte</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosPagador.fechaEmisionPasaporte}`}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Caducidad Pasaporte</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosPagador.fechaCaducidadPasaporte}`}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Fecha Ingreso País</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${datosPagador.fechaIngresoPais}`}
                        </Col>
                      </Row>
                    </div>
                  )}
              </CardBody>
            </Card>
          </Col>

          <Col lg={4} md={12} sm={12} xs={12} className="detalle-impuestos-box">
            <Card className="flex-row div-flotante">
              {totales && totales !== undefined && (
                <ValoresCotizacion
                  paso={"final-cotizacion"}
                  metodo={this.metodo}
                  valorTotal={totales}
                  estado={estado}
                  datosAdicionales={datosAdicionales}
                ></ValoresCotizacion>
              )}
            </Card>
          </Col>
        </Row>
      </Page>
    );
  }
}
export default withRouter(Cotizacion5ConfirmacionFinal);
